<template>
  <a-modal
    title="名单"
    :visible="visible"
    width="60%"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭" >
    <a-card :bordered="false">
      <!--      <div class="table-page-search-wrapper">-->
      <!--        <a-form layout="inline">-->
      <!--          <a-row :gutter="48">-->
      <!--            <a-col :md="6" :sm="24">-->
      <!--              <a-form-item label="用户名称" prop="title">-->
      <!--                <a-input v-model="queryParam.nickname" placeholder="请输入用户名称" allow-clear/>-->
      <!--              </a-form-item>-->
      <!--            </a-col>-->

      <!--            <a-col :md="!advanced && 6 || 24" :sm="24">-->
      <!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
      <!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
      <!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->

      <!--              </span>-->
      <!--            </a-col>-->
      <!--          </a-row>-->
      <!--        </a-form>-->
      <!--      </div>-->

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

  </a-modal>
</template>

<script>

import { pageBrokerage, pageBrokerageDetail } from '@/api/user/brokerage'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'BrokerageDetail',
  components: {

  },
  mixins: [tableMixin],

  data() {
    return {
      advanced: false,
      visible: false,
      multiple: false,
      list: [],
      // 展开的行，受控属性
      expandedRowKeys: [],
      replaceFields: {
        id: 'id',
        pid: 'pid',
        children: 'childList'
      },
      sortParams: {
        field: 'sort',
        way: 'ASC'
      },
      selectedRowKeys: [],
      selectedRows: [],

      ids: [],
      loading: false,
      total: 0,
      headId: null,
      // 查询参数
      queryParam: {
        title: null,
        headId: null,
        nickName: null,
        idCard: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户ID',
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'

        },
        {
          title: '所属年月',
          dataIndex: 'targetDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'idCard',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '代理合计',
          dataIndex: 'totalMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '报备ID',
          dataIndex: 'reportId',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    // this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    show(record) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.visible = true
      this.multiple = false
      this.headId = record.id
      this.queryParam.headId = record.id
      this.getList()
    },
    /** 查询引用列表 */
    getList() {
      this.loading = true
      pageBrokerageDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getHeadList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleOk() {
      this.visible = false
      this.$emit('ok')
    },
    handleCancel() {
      this.visible = false
      this.$emit('ok')
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getHeadList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getHeadList()
    },
    handleDetail(rowData) {
      this.$refs.storeUserInfo.initValue(rowData)
      this.$refs.storeUserInfo.title = '用户详情'
      this.$refs.storeUserInfo.visible = true
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      if (this.ids.length < 1) {
        that.$message.error(
          '请选择数据',
          3
        )
        return
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delBuilding(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getBuildingList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
<style lang='less' scoped></style>
